import { createFileRoute } from '@tanstack/react-router';
import { SeoTasksPage } from '@/pages/SeoTasksPage';

export const Route = createFileRoute('/_authed/seo/tasks')({
  component: SeoTasksPage,
});
